import type { SubchannelStatus } from './catalog'

type GridSortableSubchannel = {
  name: string
  status: SubchannelStatus
  connection?: { status: string } | null
}

function isLiveConnection(sub: GridSortableSubchannel): boolean {
  return (
    sub.connection?.status === 'connected' || sub.connection?.status === 'pending'
  )
}

/** Connected first, then available-not-connected, then coming soon. */
export function subchannelGridSortRank(sub: GridSortableSubchannel): number {
  if (sub.status === 'coming_soon') return 2
  if (isLiveConnection(sub)) return 0
  return 1
}

export function sortSubchannelsForGrid<T extends GridSortableSubchannel>(
  subs: T[],
): T[] {
  return [...subs].sort((a, b) => {
    const rankDiff = subchannelGridSortRank(a) - subchannelGridSortRank(b)
    if (rankDiff !== 0) return rankDiff
    return a.name.localeCompare(b.name)
  })
}
